import styled from '@emotion/styled';

export const MobileTeleHealthSpan = styled.span`
  position: relative;
  top: -2px;
`;
